import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import CustomCheckBox from 'components/CustomCheckBox'
import profileActions from 'models/ProfileInfo/actions'
import { getAutoRedeemSharesEnabled } from 'models/ProfileInfo/selectors'
import { getSharesAutoRedeemExplanationLink } from 'models/General/selectors'

import { COLOURS, EVENT_TYPE, STRING } from 'resources'
import { sendAnalyticsEvent } from 'services/analytics'

import { CheckboxContainer, Text, InfoLink, InfoIcon } from './styles'

const AutoRedeemSharesSection = () => {
  const dispatch = useDispatch()
  const autoRedeemSharesEnabled = useSelector(getAutoRedeemSharesEnabled)
  const sharesAutoRedeemExplanationLink = useSelector(getSharesAutoRedeemExplanationLink)

  const [autoRedeemChecked, setAutoRedeemChecked] = useState(autoRedeemSharesEnabled)

  const toggleAutoRedeem = () => {
    setAutoRedeemChecked((prev) => {
      if (!prev) {
        sendAnalyticsEvent(EVENT_TYPE.redemptionSharesAutoOptIn)
      }
      dispatch(profileActions.updateAccountField.init('autoRedeemSharesEnabled', !prev))
      return !prev
    })
  }

  return (
    <CheckboxContainer>
      <CustomCheckBox
        isChecked={autoRedeemChecked}
        label={<Text>{STRING.wallet.redemptions.shares.autoRedeem}</Text>}
        editable
        setChecked={toggleAutoRedeem}
        borderColour={COLOURS.neutralBlack}
        checkColour={COLOURS.darkPurple}
      />
      {!!sharesAutoRedeemExplanationLink && (
        <InfoLink href={sharesAutoRedeemExplanationLink} target="_blank" rel="noopener noreferrer">
          <InfoIcon />
        </InfoLink>
      )}
    </CheckboxContainer>
  )
}

export default AutoRedeemSharesSection
